<p>user-connections works!</p>
